(() => {
  let bannerReady;
  const loadBanner = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (bannerReady) return bannerReady;
    bannerReady = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        bannerReady = undefined;
        reject(new Error('Cookie preferences unavailable'));
      };
      document.head.append(script);
    });
    return bannerReady;
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-dheart-cookie-preferences]');
    if (!trigger) return;
    event.preventDefault();
    const error = document.getElementById('DHeartCookiePreferencesError');
    error.hidden = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      await loadBanner();
      await window.privacyBanner.showPreferences({
        locale: document.documentElement.lang,
        country: document.getElementById('DHeartCookiePreferences').dataset.country
      });
    } catch {
      error.hidden = false;
      document.getElementById('DHeartCookiePreferences').focus();
    } finally {
      trigger.removeAttribute('aria-busy');
    }
  });
})();
